package com.essntl.core.whatsapp.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WhapiChatTemplate(
    @SerialName("mark_unread")
    val markUnread: Boolean
)
